import CommonError from '../Common/CommonError'
import { error401 } from '../ErrorSvg'

const Error401Container = () => {
  return (
    <CommonError src={error401}/>
  )
}

export default Error401Container